import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ThemeService } from '@core';

@Component({
  selector: 'app-theme-toggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule],
  template: `
    <button mat-icon-button (click)="toggleTheme()" aria-label="Toggle theme">
      <mat-icon>{{ themeIcon() }}</mat-icon>
    </button>
  `,
})
export class ThemeToggleComponent {
  private theme = inject(ThemeService);

  themeIcon() {
    return this.theme.isDark ? 'dark_mode' : 'wb_sunny';
  }

  toggleTheme() {
    this.theme.toggle();
  }
}
